module.exports = __webpack_public_path__ + "img/preview-11.59807f81.jpg";